'use client';
import { jsx } from 'react/jsx-runtime';
import { useMemo, useEffect } from 'react';
import { SwanContext } from './swan-provider.context.js';
import { createSwanGlobalObject, createSwanVersionMetaTag } from '../../../core/utilities/swan-version.js';
import { loadSwanPolyfill } from '../../../core/utilities/load-polyfill.js';
import { getSwanBaseUrl } from '../../../core/utilities/base-url.utils.js';
import { SwanPathTypeEnum } from '../../../core/types/enums.js';

createSwanVersionMetaTag();
let p = SwanPathTypeEnum.hashed;
const SwanProvider = ({ swanBaseUrl: t, pathType: s, swanPathType: c, swanTenant: d, swanLocale: l, globalLinkComponent: w, children: v })=>{
    let f = t || getSwanBaseUrl(d, l), x = c || s || p, P = useMemo(()=>({
            globalLinkComponent: w,
            swanBaseUrl: f,
            swanPathType: x,
            swanTenant: d,
            swanLocale: l
        }), [
        w,
        f,
        x,
        d,
        l
    ]);
    return useEffect(()=>{
        createSwanGlobalObject(P.swanBaseUrl);
    }, [
        P.swanBaseUrl
    ]), useEffect(()=>{
        loadSwanPolyfill(f);
    }, [
        f
    ]), jsx(SwanContext.Provider, {
        value: P,
        children: v
    });
};
SwanProvider.displayName = 'SwanProvider';

export { SwanProvider };
